import type { Locale } from '@tuic/i18n';
import { CacheTag } from '../../utils';
import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { Pcl } from '../../index';
import { logger } from '@tuic/logger';

/**
 * Returns the BusStations from the PCL.
 */
export const getBusStations = async (
  locale: Locale,
): Promise<Pcl.Busstation[]> => {
  let { data, error } = await Pcl.getBusstations({
    query: { locale },
  });

  if (error) {
    logger.error(`Could not fetch bus stations. Locale: ${locale}`);
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Returns the BusStations from the PCL.
 */

export const cachedGetBusStations: typeof getBusStations = locale => {
  return remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getBusStations', locale]),
    () => getBusStations(locale),
    {
      tags: [
        CacheTag.pcl,
        CacheTag.busStationResource,
        CacheTag.getBusStations,
      ],
      ttl: 600,
    },
  );
};
